export default {"src":"https://webcdn.trailways.com/_next/static/media/error-circle.1f607583.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};